module.exports = __webpack_public_path__ + "static/screen-assessment-e6edcb39351cd145783ba7238dbf2f50.png";